import styled from "styled-components";
import * as shared from "../styles/shared.js";
import * as vars from "../styles/variables.js";

const NextPrev = styled.button`
  ${shared.buttonReset};
  position: absolute;
  top: 50%;
  width: 1.5rem;
  height: 1.5rem;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
  transition: opacity 0.2s ease;
  padding: 0;
  backface-visibility: hidden;

  &:before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
  }

  svg {
    width: 100%;
    height: auto;
    pointer-events: none;
  }

  @media (hover: hover) {
    &:hover {
      polygon {
        fill: ${vars.colours.accentRed} !important;
      }
    }
  }
  
  @media (hover: none) {
    &:active {
      polygon {
        fill: ${vars.colours.accentRed} !important;
      }
    }
	}

  &.swiper-button-disabled {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Prev = styled(NextPrev)`
  left: 15px;
`;

export const Next = styled(NextPrev)`
  right: 15px;
`;
